'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activateProduct = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _tracker = require('ui-addon-upgrades/_core/common/eventTracking/tracker');

var tracker = _interopRequireWildcard(_tracker);

var _activateByProduct = require('ui-addon-upgrades/_core/common/api/activateByProduct');

var _productActivation = require('ui-addon-upgrades/_core/common/constants/productActivation');

var _wrapWithErrorMonitoring = require('ui-addon-upgrades/_core/common/reliability/wrapWithErrorMonitoring');

var _wrapWithErrorMonitoring2 = _interopRequireDefault(_wrapWithErrorMonitoring);

var _ProductActivationPrompt = require('ui-addon-upgrades/_core/productActivation/ProductActivationPrompt');

var _auth = require('hub-http/auth');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var activateProduct = exports.activateProduct = (0, _wrapWithErrorMonitoring2.default)('activateProduct', function (upgradeData, onSuccess) {
  var upgradeProduct = upgradeData.upgradeProduct;

  var activationType = _productActivation.upgradeProductToActivationType[upgradeProduct];
  return (0, _activateByProduct.activateByProduct)(activationType).then(function () {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('productActivationInteraction', _extends({
      action: 'activation succeeded'
    }, upgradeData));
    (0, _ProductActivationPrompt.ProductActivationPrompt)({ upgradeData: upgradeData, onSuccess: onSuccess });
  }).then(function () {
    return (0, _auth.refreshCookie)(_hubspot2.default.get(), true);
  }).catch(function (e) {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('productActivationInteraction', _extends({
      action: 'activation failed'
    }, upgradeData));
    _devLogger2.default.warn({ message: e, key: 'ProductActivationButton' });
    if (window.Raven) {
      window.Raven.captureMessage('Product activation failed', {
        extra: { error: e }
      });
    }
    (0, _ProductActivationPrompt.ProductActivationPrompt)({ upgradeData: upgradeData, hasError: true });
  });
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/productActivation/activateProduct.js
// module id = 649
// module chunks = 3 4